import React from 'react';

export const FooterArrow = () => (
    <svg
        width="14px"
        height="8px"
        viewBox="0 0 14 8"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
    >
        <defs />
        <g
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <g transform="translate(-1287.000000, -617.000000)" stroke="#6C7782" strokeWidth="1.5">
                <g>
                    <g transform="translate(120.000000, 593.000000)">
                        <g transform="translate(1040.000000, 4.000000)">
                            <g transform="translate(124.000000, 14.000000)">
                                <polyline points="15.8333333 7.22971609 10.0037493 13.0555556 4.16666667 7.22222222" />
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);
